/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { Log } from '../logging';
import { Screen } from './Screen';

/* eslint-disable class-methods-use-this */
export class ScreenController {
    private static readonly TAG: string = 'ScreenController';

    private mScreenControllerStack: Array<Screen<any>>;

    private mStackChangeListners: Array<() => void>;

    private static oScreenController?: ScreenController;

    private constructor() {
        this.mScreenControllerStack = [];
        this.mStackChangeListners = [];
    }

    private notifyStackChangeListener(): void {
        this.mStackChangeListners.forEach((callback) => callback());
    }

    public static getInstance() {
        if (!ScreenController.oScreenController) {
            ScreenController.oScreenController = new ScreenController();
        }
        return ScreenController.oScreenController;
    }

    // Method implementation will be done in KST-7920
    private updateStack() {}

    public addStackChangeListener(callback: () => void): void {
        this.mStackChangeListners.push(callback);
    }

    public emptyScreenControllerStack = () => {
        this.mScreenControllerStack = [];
    };

    public getScreen<T>(): Screen<T> {
        if (this.mScreenControllerStack.length) {
            // returning top element in stack
            return this.mScreenControllerStack[this.mScreenControllerStack.length - 1];
        }
        throw new Error(`${ScreenController.TAG} - Empty stack! Cann't perform get operation.`);
    }

    public onKeyBack() {
        try {
            this.pop();
        } catch (error) {
            Log.e(ScreenController.TAG, `${error}`);
        }
    }

    public pop() {
        if (this.mScreenControllerStack.length) {
            this.mScreenControllerStack.pop();
            this.notifyStackChangeListener();
        } else
            throw new Error(`${ScreenController.TAG} - Empty stack! Cann't perform pop operation.`);
    }

    public popAllMatching(match: string) {
        if (this.mScreenControllerStack.length === 0)
            throw new Error(`${ScreenController.TAG} - Empty stack! Cann't perform pop operation.`);

        for (let i = this.mScreenControllerStack.length - 1; i >= 0; i -= 1) {
            if (this.mScreenControllerStack[i].getIdentifier().includes(match))
                this.mScreenControllerStack.pop();
            else break;
        }
    }

    public push<T>(screen: Screen<T>) {
        if (this.mScreenControllerStack.length === 0) {
            this.mScreenControllerStack.push(screen);
        }
        if (screen.getIdentifier() !== this.getScreen().getIdentifier()) {
            this.mScreenControllerStack.push(screen);
        }
        this.notifyStackChangeListener();
    }

    public removeStackChangeListener(callback: () => void): void {
        this.mStackChangeListners = this.mStackChangeListners.filter((cb) => cb !== callback);
    }
}
